import React from "react";
import toast from "react-hot-toast";
import {
  HiOutlineCheck,
  HiOutlineExclamationTriangle,
  HiOutlineXMark,
} from "react-icons/hi2";

type ToastType = "success" | "error" | "warning";

interface ToastProps {
  message: string;
  type?: ToastType;
}

interface ToastConfig {
  icon: React.ComponentType<{ size: number; className: string }>;
  bgColor: string;
}

const toastConfigs: Record<ToastType, ToastConfig> = {
  success: {
    icon: HiOutlineCheck,
    bgColor: "bg-success-500",
  },
  error: {
    icon: HiOutlineXMark,
    bgColor: "bg-error-500",
  },
  warning: {
    icon: HiOutlineExclamationTriangle,
    bgColor: "bg-warning-500",
  },
};

const toastMessage = ({ message, type = "success" }: ToastProps) => {
  const config = toastConfigs[type];
  const Icon = config.icon;

  toast(() => (
    <section className="justify-center items-center gap-1 flex">
      <div
        className={`w-6 h-6 ${config.bgColor} rounded-full flex justify-center items-center shrink-0`}
      >
        <Icon size={18} className="text-white shrink-0" />
      </div>
      <div className="w-full text-center text-white text-base font-medium">
        {message}
      </div>
    </section>
  ));
};

export { toastMessage };
